import {useTranslation} from 'react-i18next';
import * as css from './PromotionHeader.css';

const PromotionHeader = () => {
    const {t} = useTranslation('realtime');
    return (
        <css.titleBlock>
            <css.title>{t('promotionSummaryTitle')}</css.title>
            <css.subtitle>{t('promotionSummarySubtitle')}</css.subtitle>
        </css.titleBlock>
    );
};

export default PromotionHeader;
